import { z } from 'zod'
import { oc } from '@orpc/contract'

// The secret key is write-only at this boundary: it is accepted on save,
// stored in dynamic-settings, and never returned by any endpoint.
export const setOrganizationStripeKeys = oc
  .route({ method: 'POST', path: '/v2/super/organizations/{organizationId}/stripe-keys' })
  .input(
    z.object({
      organizationId: z.string().min(1),
      publishableKey: z.string().trim().startsWith('pk_', 'Expected a Stripe publishable key'),
      secretKey: z
        .string()
        .trim()
        .regex(/^(sk|rk)_/, 'Expected a Stripe secret key'),
    }),
  )
  .output(
    z.object({
      configured: z.literal(true),
      publishableKey: z.string(),
      webhookRegistered: z.boolean(),
    }),
  )

export const getOrganizationStripeStatus = oc
  .route({ method: 'GET', path: '/v2/super/organizations/{organizationId}/stripe-keys' })
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(
    z.object({
      configured: z.boolean(),
      publishableKey: z.string().optional(),
    }),
  )
